export default __webpack_public_path__ + "static/media/worker5.eae5b14c.jpg";